import { useScrollReveal } from '@/hooks/useScrollReveal';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const SERVICE_META = [
  { icon: 'ri-file-list-3-line', color: 'bg-gray-50', iconColor: 'text-teal-500', link: '/regulations#business' },
  { icon: 'ri-shield-check-line', color: 'bg-teal-50', iconColor: 'text-teal-500', link: '/regulations#health' },
  { icon: 'ri-truck-line', color: 'bg-teal-50', iconColor: 'text-teal-500', link: '/regulations#vehicle' },
];

export default function ServicesOverview() {
  const ref = useScrollReveal<HTMLDivElement>();
  const { t } = useTranslation();
  const services = t('services.items', { returnObjects: true }) as {
    title: string;
    description: string;
  }[];

  return (
    <section id="services" className="py-24 bg-white">
      <div ref={ref} className="max-w-7xl mx-auto px-6 reveal-on-scroll animate-fade-in-up">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="inline-block bg-teal-50 text-teal-500 text-xs font-bold uppercase tracking-widest px-4 py-2 rounded-full mb-4">
            {t('services.tag')}
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 leading-tight">
            {t('services.title1')}<br />
            <span className="text-teal-500">{t('services.title2')}</span>
          </h2>
          <p className="mt-5 text-gray-500 text-base md:text-lg max-w-2xl mx-auto leading-relaxed">
            {t('services.subtitle')}
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, i) => (
            <Link
              to={SERVICE_META[i].link}
              key={service.title}
              className={`${SERVICE_META[i].color} rounded-2xl p-7 hover:shadow-md transition-all duration-300 group cursor-pointer`}
              style={{ animationDelay: `${i * 0.1}s` }}
            >
              <div
                className={`w-12 h-12 flex items-center justify-center rounded-xl bg-white mb-5 ${SERVICE_META[i].iconColor}`}
              >
                <i className={`${SERVICE_META[i].icon} text-2xl`} />
              </div>
              <h3 className="font-semibold text-gray-900 text-lg mb-3">{service.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{service.description}</p>
              <div className={`mt-5 flex items-center gap-1 text-sm font-semibold ${SERVICE_META[i].iconColor}`}>
                {t('services.learnMore')} <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform" />
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}